import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent } from "@mui/material";

import MakePresenter from "presenters/MakePresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import EmailForm from "components/EmailForm";
import SpinningCloseButton from "components/SpinningCloseButton";
import { useShares, useLoading } from "hooks";

import ShareOptions from "./components/ShareOptions";
import useStyles from "./useStyles";

const ShareModal = (props) => {
  const { onClose, text, make, autoShowCVPModal, setShowCVPModalNext, templateGroup } = props;
  const [emailFormVisible, setEmailFormVisible] = useState(false);
  const classes = useStyles();
  const { createShare } = useShares();
  const { func: createShareWithLoader, isPending, isFulfilled } = useLoading(createShare);

  const handleEmailFormOpen = () => setEmailFormVisible(true);

  const url = window.location.href;

  return (
    <Dialog
      classes={{ root: classes.root }}
      PaperProps={{ classes: { root: classes.paper } }}
      open
      onBackdropClick={() => onClose()}
      data-testid="shareModal-container"
    >
      <SpinningCloseButton onClick={() => onClose()} />

      <DialogContent className={classes.dialogContent}>
        {emailFormVisible ? (
          <EmailForm
            isPending={isPending}
            isFulfilled={isFulfilled}
            onSubmit={createShareWithLoader}
            setShowCVPModalNext={setShowCVPModalNext}
            make={make}
            templateGroup={templateGroup}
          />
        ) : (
          <ShareOptions
            autoShowCVPModal={autoShowCVPModal}
            onEmailFormOpen={handleEmailFormOpen}
            onClose={onClose}
            make={make}
            message={{ url, text }}
            templateGroup={templateGroup}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

ShareModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  text: PropTypes.string,
  make: MakePresenter.shape().isRequired,
  autoShowCVPModal: PropTypes.func.isRequired,
  setShowCVPModalNext: PropTypes.func.isRequired,
  templateGroup: TemplateGroupPresenter.shape().isRequired,
};

ShareModal.defaultProps = {
  text: "",
};

export default ShareModal;
